<template>
	<div class="app-warapper">
		<AppHeader />
		<AppMain />
		<AppFooter />
	</div>
</template>
<script>
import AppHeader from './components/AppHeader'
import AppMain from './components/AppMain'
import AppFooter from './components/AppFooter'
export default {
	name: 'Layout',
    components:{
			AppHeader,
			AppMain,
			AppFooter
	},
	computed: {
	},
	created() {
	},
	watch: {
	},
	methods:{
	}
}
</script>
<style lang="scss" scoped>
.app-warapper{
}
</style>
